import styled from '@emotion/styled';
import { BaseModal } from '@anyroad/modal';
import { FormattedMessage } from 'react-intl';
import { Content, SuccessModalText, SuccessButton } from './styles';

type SuccessModalProps = {
  onClose: () => void;
};

const SuccessModal = ({ onClose }: SuccessModalProps) => {
  return (
    <Content>
      <SuccessModalText>
        <FormattedMessage
          id="THANK_YOU_YOU_HAVE_BEEN_ADDED_TO_THE_WAITLIST_FOR_YOUR_SELECTED_TIMESLOT"
          defaultMessage="Thank you! You have been added to the waitlist for your selected timeslot(s). We will email you if and when a spot becomes available."
          description="Success message displayed after joining the waitlist"
        />
      </SuccessModalText>
      <SuccessButton
        data-testid="waitlist-success-btn"
        className="brand-bg brand-border"
        color="primary"
        onClick={onClose}
        type="button"
      >
        <FormattedMessage
          id="OK"
          defaultMessage="OK"
          description="Button text to close the success modal"
        />
      </SuccessButton>
    </Content>
  );
};

const WaitlistSuccess = BaseModal<SuccessModalProps>(SuccessModal, {
  isCloseButtonHidden: true,
  padding: '42px 32px',
  width: '600px',
});

export const WaitlistSuccessModal = styled(WaitlistSuccess)<SuccessModalProps>`
  @media (min-width: 768px) {
    margin-top: -50vh;
  }
  @media (max-width: 768px) {
    width: 312px;
    padding: 53px 16px 32px;
    min-height: 159px;
    text-align: center;
    font-size: 13px;
    margin: auto;
  }
`;
